"use client";
import React, { useState } from 'react';
import Image from 'next/image';
import "../../scss/_contact-us.scss";
import contactImage from '../../../public/icons/hero.png';
import banner from './../../../public/icons/formbanner.jpg';
import { getContactUs } from '@/services/publicService';
import { showError, showSuccess } from '@/utils/toast';

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // validate phone number
  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{1,15}$/;
    return phoneRegex.test(phoneNumber);
  };

  // validate email
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(formData.email)) {
      showError('Please enter a valid email');
      return;
    }
    if (!validatePhoneNumber(formData.phone)) {
      showError('Please enter a valid phone number');
      return;
    }
    try {
      const response = await getContactUs(formData);
      if (response.status == 201) {
        showSuccess(response.message);
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        showError(response.message);
      }
    } catch (error) {
      showError(error?.response?.data?.message || 'An error occurred. Please try again.');
    }
  };

  return (
    <div className="contact-us-page-cu">
      <section className="contact-section-cu">
        <div className="contact-us-wrapper"></div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="contact-title-cu">We&apos;d love to hear from you!</h1>
            </div>
          </div>
          <div className="row align-items-start form-wrapper">
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0 p-0">
              <div className="contact-image-wrapper-cu">
                <Image 
                  src={banner} 
                  alt="Tanker truck on mountain road" 
                  className="contact-image-cu"
                  fill
                  priority
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 p-0">
              <div className="contact-form-wrapper-cu">
                <h2>Contact Us</h2>
                <form className="contact-form-cu" onSubmit={handleSubmit}>
                  <div className="form-group-cu">
                    <label htmlFor="name" className="form-label-cu">
                      Name <span className="required-cu">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control-cu"
                      placeholder="Enter your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group-cu">
                    <label htmlFor="email" className="form-label-cu">
                      Your Email <span className="required-cu">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control-cu"
                      placeholder="Enter your email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  
                  <div className="form-group-cu">
                    <label htmlFor="phone" className="form-label-cu">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control-cu"
                      placeholder="Enter your Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="form-group-cu">
                    <label htmlFor="message" className="form-label-cu">
                      Message
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      className="form-control-cu form-textarea-cu"
                      placeholder="Type your message here..."
                      rows="6"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  
                  <button type="submit" className="btn-submit-cu">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

